import React from 'react';
import PropTypes from 'prop-types'
import { i18n } from 'react-i18n'
import $ from 'jquery'
import AppDispatcher from '../../dispatcher/AppDispatcher'

import TemplateData from '../../utility/getTemplateData'

export default React.createClass({

	mixins: [i18n('confirmation/postTransaction')],

	getInitialState() {

		let postdata = this.props.postdata || {}
		let postBackData = postdata.postBackData || {}
		let syncIpnUrl = postdata.syncReturnUrl || ''
		let postBackArray = []

		Object.keys(postBackData).forEach(function(key) {
			postBackArray.push({
				name: key,
				value: postBackData[key]
			})
		})

		return {
			orgName: this.props.orgName,
			redirectMethod: this.props.method,
			redirectUrl: this.props.action,
			syncIpnUrl: syncIpnUrl,
			postBackArray: postBackArray
		};
	},

	componentDidMount() {

		this.handleRedirect()

		//No need to handle refresh case
		//As user will be automatically redirected back
		//In case if some is required, listening to UPDATE_CONFIRMATION
		// AppDispatcher.register(function(payload) {
		//	 if (payload.action && (payload.action.actionType === 'UPDATE_CONFIRMATION')) {}
		// });
	},

	handleRedirect() {

		let that = this

		setTimeout(function(){
			$('.spinneroverlay').show()
		}, 12000)

		setTimeout(function(){
			$.get('/donate/sessionlogout').always(function() {
				if (that.state.syncIpnUrl){
					window.location.href = that.state.syncIpnUrl
				} else if (that.state.redirectMethod === 'POST'){
					$('form[name=postBackForm]').submit()
				} else {
					window.location.href = that.state.redirectUrl
				}
			})
		}, 15000)
	},

	render() {

		if (this.state.orgName) {
			let redirectText = this.i18n('label.redirectText')
			redirectText = redirectText.replace('{orgName}', this.state.orgName)
			document.getElementById('spinnerText').innerHTML = redirectText
		}

		return (
			<div>
				<form name="postBackForm"  method={this.props.method} action={this.props.action}> {
					this.state.postBackArray.map(function(obj) {
						return <input type="hidden" key={obj.name} name={obj.name} defaultValue={obj.value} />
					})
				}
				</form>
			</div>
		);
	}
});



// WEBPACK FOOTER //
// ./pages/confirmation/postTransaction.js